export class CityFilter {
    static sortOrder: string;
    static cityList: Array<any> = new Array();
    static userModel: any;
    static pageIndex: any;
    static sortBy: string;
    static statusList: Array<any> = new Array();
    //static onlyContactMeLater: boolean;
    static ownerName: string;
  }
export class UsersFilterService {
	static sortOrder: string;
	static statusList: Array<any> = new Array();
	static cityList: Array<any> = new Array();
	static sortBy : string;
	static roleList: Array<any> = new Array();
	static officesList: Array<any> = new Array();
	static floors: Array<any> = new Array();
	static startDate: Date;
	static endDate: Date;
	static feature:string;
	static ownerId:string;
	static onlyDeleted: boolean;
	static userModel : any;
	static pageIndex : any;
	//static onlyContactMeLater: boolean;
	static ownerName: string;
}

export class EmployeeFilter {
	static sortOrder: string;	
	static cityList: Array<any> = new Array();
	static emailList: Array<any> = new Array();
	static officesList: Array<any> = new Array();	
	static sortBy : string;
	static checkinList: Array<any> = new Array();	
	static startDate: Date;
	static endDate: Date;			
	static userModel : any;
	static pageIndex : any;
	static fromDate : any;
	static toDate : any;
	//static onlyContactMeLater: boolean;
	static ownerName: string;
	static ModeList:Array<any> = new Array();
	static BadagestatusList:Array<any>=new Array();
	static EmployeeListType:Array<any>=new Array();
}
export class AuditTrailFilterService {
    static sortOrder: string;
    static actionPerformedList: Array<any> = new Array();
    static actionPerformedOnList: Array<any> = new Array();
    static sortBy : string;
    static startDate: Date;
    static endDate: Date;
    static feature:string;
    static ownerId:string;
    static onlyDeleted: boolean;
    static userModel : any;
    static pageIndex : any;
	static changeByList : Array<any> = new Array();
    static ownerName: string;
	static changedAttributeList:Array<any>=new Array();
  }
export class OfficeFilter {
	static sortOrder: string;	
	static cityList: Array<any> = new Array();	
	static userModel : any;
	static pageIndex : any;
	static sortBy : string;
	static statusList: Array<any> = new Array();
	//static onlyContactMeLater: boolean;
	static ownerName: string;
}

export class InwardFilter{
	static sortOrder: string;	
	static cityList: Array<any> = new Array();	
	static userModel : any;
	static pageIndex : any;
	static sortBy : string;
	static statusList: Array<any> = new Array();
	static broughtFromList : Array<any> = new Array();
	static receivedByList : Array<any> = new Array();
	static regTypeList : Array<any> = new Array();
}
export class outwardFilter{
	static sortOrder: string;	
	static cityList: Array<any> = new Array();	
	static officeList: Array<any> = new Array();	
	static userModel : any;
	static pageIndex : any;
	static sortBy : string;
	static statusList: Array<any> = new Array();
	static regTypeList : Array<any> = new Array();
}

export class filterData {
   
    page: number;
    sortBy: string;
    sortOrder: string;
   
}

export class AuditTrailFilter{
	static sortOrder: string;
	static sortBy:string;	
	static startDate: Date;
	static endDate: Date;
	static pageIndex : any;
	static fromDate : any;
	static toDate : any;
	static ownerName: string;
	static changedByList:Array<any>=new Array();
	static changedAttributeList:Array<any>=new Array();
}




